import React from 'react';
import { Link } from 'react-router-dom';
import { BellIcon } from 'lucide-react';
export function IncompleteRegistrationBanner() {
  return <Link to="/dashboard" className="flex min-h-[80px] items-center gap-4 bg-go px-6 py-4 text-white transition-colors duration-150 hover:bg-[#008A3A]" data-id="element-142" data-mp="2citkh1rvu1w2">
      <BellIcon className="h-8 w-8 shrink-0" strokeWidth={2} aria-hidden data-id="element-143" data-mp="22sqrv2ooapy9" />
      <span className="text-lg font-bold md:text-xl" data-id="element-144" data-mp="2qgrwi0iqdm8e">You have incomplete registration(s), click here to complete.</span>
    </Link>;
}